<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="pa-1 mb-1">
        <v-list-item class="px-1">
            <v-list-item-content class="pa-1 ma-0 body-2">
                <v-list-item-title class="title body-2">
                    {{model.title}}
                </v-list-item-title>
                <v-list-item-subtitle class="title body-2">
                    {{ url}}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="title body-2">
                    {{ model.url}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions class="py-0">
            <v-container fluid class="py-0">
                <v-row>
                    <v-col cols="9" md="9" class="pa-0 pa-0 d-flex">
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <span v-on="on" class="text-center align-self-center">
                                    {{formattedDate}} {{formattedTime}}
                                </span>
                            </template>
                            <span class="caption">Дата создания <br> {{formattedDate}} <br> {{formattedTime}}</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="3" class="pa-0 pa-0">
                        <v-btn x-small icon color="blue lighten-3" @click="$emit('editModel', index)"
                               v-if="visibleButtons !== undefined ? visibleButtons.hasOwnProperty('editButton') : true"
                        >
                            <v-icon small>edit</v-icon>
                        </v-btn>
                        <v-btn x-small icon color="red lighten-2" @click="$emit('removeModel', index)"
                               v-if="visibleButtons !== undefined ? visibleButtons.hasOwnProperty('removeButton') : true"
                        >
                            <v-icon small>delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col cols="2" class="pa-0 pa-0">
                        <v-tooltip left class="">
                            <template v-slot:activator="{ on }">
                                <v-card
                                        color="success"
                                        dark
                                        v-on="on"
                                        class="text-center body-2"
                                        outlined
                                >
                                    <v-icon small>launch </v-icon>
                                     {{model.all_jumps}}
                                </v-card>
                            </template>
                            <span>Всего переходов {{model.all_jumps}}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-actions>
    </v-card>
</template>

<script>
import constConf from '../../../constconf'
export default {
    name: 'JumpCard',
    props: ['model', 'index', 'visibleButtons'],
    methods: {
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        }
    },
    computed: {
        formattedDate() {
            let theDate = new Date(this.model.created_at * 1000)
            return this.zero(theDate.getDate()) + '.' + this.zero((theDate.getMonth() + 1)) + '.' + theDate.getFullYear()
        },
        formattedTime() {
            let theDate = new Date(this.model.created_at * 1000)
            return this.zero(theDate.getHours()) + ':' + this.zero((theDate.getMinutes()))
        },
        url() {
            return constConf.baseURL.url + '/' + this.model.id
        }
    }
}
</script>

<style scoped>

</style>
